module.exports = __webpack_public_path__ + "images/xpms全景_02.jpg?v=f9133809";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/lvyue2/xpms全景_02.jpg
 ** module id = 125
 ** module chunks = 1 2
 **/